$(document).ready(function () {
  function getWorldTime(tzOffset) {
    var now = new Date();
    var tz =
      now.getTime() + now.getTimezoneOffset() * 60000 + tzOffset * 3600000;
    now.setTime(tz);

    var s =
      leadingZeros(now.getFullYear(), 4) +
      "-" +
      leadingZeros(now.getMonth() + 1, 2) +
      "-" +
      leadingZeros(now.getDate(), 2) +
      " " +
      leadingZeros(now.getHours(), 2) +
      ":" +
      leadingZeros(now.getMinutes(), 2) +
      ":" +
      leadingZeros(now.getSeconds(), 2);

    return s;
  }

  function leadingZeros(n, digits) {
    var zero = "";
    n = n.toString();

    if (n.length < digits) {
      for (i = 0; i < digits - n.length; i++) zero += "0";
    }
    return zero + n;
  }

  var now_addr = window.location.href;
  var preview = now_addr.split("?preview=");
  var preview_ = now_addr.split("&preview=");

  if (getWorldTime(+9) < "2024-07-25 00:00:00") {
    if (
      $("product-info").length > 0 &&
      $(".product__title h1").attr("rel") == "7196140241005"
    ) {
      $(".normal_tab").before(
        '<div class="promotion_vis"><img src="https://cdn.shopify.com/s/files/1/0573/6408/6893/files/e50a8c5b7878a93d3442e1834be1a5df.png?v=1721211069"></div>'
      );
    }
  }

  if (
    (getWorldTime(+9) > "2024-12-03 20:00:00" &&
      getWorldTime(+9) < "2024-12-09 01:00:00") ||
    preview[1] == "black" ||
    preview_[1] == "black"
  ) {
    $(".main_vis").hide();
    $(".main_vis").before(
      '<div class="promotion_vis main_prm"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0573/6408/6893/files/long_BF_main_pc_24.11.20.png?v=1733107240" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0573/6408/6893/files/long_BF_main_MO_24.11.20.png?v=1733107239" class="promotion_mo"></a></div>'
    );
    // $(".normal_tab, .detail_set").before(
    //   '<div class="promotion_vis"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0573/6408/6893/files/long_BF_main_pc_24.11.20.png?v=1733107240" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0573/6408/6893/files/long_BF_main_MO_24.11.20.png?v=1733107239" class="promotion_mo"></a></div>'
    // );

    $(".main_slide.promotion_vis").hide();
    $(".main_slide_fade.promotion_vis").show();
    $(".prm_inst, .promotion_vis.dual").remove();
    $(".promotion_bar_mother").show();

    $(".swiper-button-next").remove();
    $(".swiper-button-prev").remove();

    // setTimeout(function(){
    //      let main_bnr_lenth = $('.main_slide_fade .swiper-slide').length;
    //      var main_bnr = new Swiper(".main_slide .swiper-container", {
    //         effect: "fade",
    //          speed:1000,
    //          loop: true,
    //          autoplay : {
    //            delay : 1400,
    //            disableOnInteraction : false,
    //          },
    //          // pagination: {
    //          //     el: ".main_slide .swiper-pagination",
    //          // },
    //          // navigation: {
    //          //   nextEl: '.main_slide .swiper-button-next',
    //          //   prevEl: '.main_slide .swiper-button-prev',
    //          // },
    //      });
    //  },1000)
  } else {
    // $(".main_slide .prm").remove();
    $(".main_vis").remove();

    $(".main_slide_fade.promotion_vis").hide();
    $(".main_vis").before("");
    $(".promotion_bar_mother").hide();
    $(".promotion_bar_event").remove();

    setTimeout(function () {
      let main_bnr_lenth = $(".main_slide .swiper-slide").length;
      var main_bnr = new Swiper(".main_slide .swiper-container", {
        speed: 1000,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        // pagination: {
        //     el: ".main_slide .swiper-pagination",
        // },
        navigation: {
          nextEl: ".main_slide .swiper-button-next",
          prevEl: ".main_slide .swiper-button-prev",
        },
      });
    }, 1000);
  }

  /*
  if (getWorldTime(+9) > "2024-01-19 17:00:00") {
  } else {
    $(".main_vis").before(
      '<div class="promotion_vis main_prm"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/PC.png?v=1708584434" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/MO.png?v=1708584437" class="promotion_mo"></a></div>'
    );

    if ($(".product__title h1").length > 0) {
      var promotionTitle = $(".product__title h1").text();
      var promotionRel = $(".product__title h1").attr("rel");
      console.log(promotionRel);
      if (
        promotionRel == "8845702365474" ||
        promotionRel == "8845709934882" ||
        promotionRel == "8845707968802" ||
        promotionRel == "8845718323490"
      ) {
        $(".normal_tab, .detail_set").before(
          '<div class="promotion_vis"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/3._pc_Msw2_Ayj5.png?v=1704687551" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/1._mo_Msw2_Ayj5.png?v=1704687551" class="promotion_mo"></a></div>'
        );
      } else if (promotionRel == "8719285059874") {
        $(".normal_tab, .detail_set").before(
          '<div class="promotion_vis"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/3._pc_Msw2_Ayj5.jpg?v=1704687551" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/1._mo_Msw2_Ayj5.png?v=1704687551" class="promotion_mo"></a></div>'
        );
      } else if (promotionRel == "8719291384098") {
        $(".normal_tab, .detail_set").before(
          '<div class="promotion_vis"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/2._pc_Msw2_Ayj5.jpg?v=1704687550" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/1._mo_Msw2_Ayj5.png?v=1704687551" class="promotion_mo"></a></div>'
        );
      }
      if (
        promotionRel == "8845709934882" ||
        promotionRel == "8845707968802" ||
        promotionRel == "8845718323490" ||
        promotionRel == "8719285059874" ||
        promotionRel == "8719291384098"
      ) {
        $(
          ".product--medium:not(.product--no-media) .product__info-wrapper"
        ).append(
          "<div class='fs16' style='margin-top:20px'><strong class='fs30' style='color:red; display:block; margin-bottom:10px'>Free Gift Offer!</strong>If you buy our newest products, 'Soothing Cream' or 'Feminine Deodorant Spray',<br/>  we give you a package of Feminine Trial Kit for FREE! <span style='color:red'>*Please Note !!</span>: ADD 'Feminine Trial Kit' (qty: 1) TO YOUR CART to get the FREE GIFT! Discount is automatically applied ONLY WHEN YOU ADD 'Feminine Trial Kit' to your cart!</div>"
        );
      }
      else if (
        promotionRel == "8845702365474" ||
        promotionRel == "8269927481634" ||
        promotionRel == "8269928235298" ||
        promotionRel == "8845746962722"
      ) {
        $(
          ".product--medium:not(.product--no-media) .product__info-wrapper"
        ).append(
          "<div class='fs16' style='margin-top:20px'><strong class='fs30' style='color:red; display:block; margin-bottom:10px'>!! Free Gift Notice !!</strong>We are offering a Free 'Feminine Trial Kit' ONLY TO customers who purchased at least one of our NEW PRODUCTS ! (Soothing Cream, Intimate Deodorant Spray) <br/> <span style='color:black'>!! If you </span>make a purchase that EXCLUDES the NEW PRODUCTS, the FREE GIFT offer does not apply.</div>"
        );
      }
      */
  /*
      color + shop page change
      
      $('.announcement-bar').css({'background':'#ca0003'});
      $('.announcement-bar a span, .announcement-bar span').css({'color':'#fff'});
      $('.collection-hero .left_img, .collection-hero .right_img').remove();
      $('.collection_sub li a.on').css({'color':'#ca0003'});
      $('.sale_bd').css({'background':'#ca0003', 'color':'#fff'});
      $('.grid__item .free_ico img').attr('src','https://cdn.shopify.com/s/files/1/0715/3385/5010/files/free_shipping.png?v=1703054728');
      $('.card-information .product_desc').css({'color':'#3c876b'});
      $('.quick-add').addClass('xmas');
      
      if($(window).width() < 990){
        $('.main_prm').css({'background':'url("https://cdn.shopify.com/s/files/1/0715/3385/5010/files/231220____gif___jpg_____vF.jpg?v=1703062579") no-repeat center/cover','height':'0', 'padding':'0 0 119.8% 0'});       
        $('.collection-hero').css({'background':'url("https://cdn.shopify.com/s/files/1/0715/3385/5010/files/mo_Msw2_Ayj5.png?v=1703054006") no-repeat center/cover'});       
        if($(window).width() < 450){             
          $('.collection-hero').css({'background':'url("https://cdn.shopify.com/s/files/1/0715/3385/5010/files/mo_Msw2_Ayj5_d38da8ed-727b-47e1-a426-8c187cc0586e.png?v=1703062537") no-repeat center/cover'}); 
        }
      }else{      
        $('.main_prm').css({'background':'https://cdn.shopify.com/s/files/1/0715/3385/5010/files/231220____gif_PC_jpg_____vF.jpg?v=1703062579") no-repeat center/cover','height':'0', 'padding':'0 0 32.8% 0'});       
        $('.collection-hero').css({'background':'url("https://cdn.shopify.com/s/files/1/0715/3385/5010/files/pc_Msw2_Ayj5.png?v=1703054006") no-repeat center/cover'}); 
      }      
    
      function resizeShopBg(){
        if($(window).width() < 990){
          $('.main_prm').css({'background':'url("https://cdn.shopify.com/s/files/1/0715/3385/5010/files/231220____gif___jpg_____vF.jpg?v=1703062579") no-repeat center/cover','height':'0', 'padding':'0 0 119.8% 0'});       
          $('.collection-hero').css({'background':'url("https://cdn.shopify.com/s/files/1/0715/3385/5010/files/mo_Msw2_Ayj5.png?v=1703054006") no-repeat center/cover'});       
          if($(window).width() < 450){             
            $('.collection-hero').css({'background':'url("https://cdn.shopify.com/s/files/1/0715/3385/5010/files/mo_Msw2_Ayj5_d38da8ed-727b-47e1-a426-8c187cc0586e.png?v=1703062537") no-repeat center/cover'}); 
          }
        }else{      
          $('.main_prm').css({'background':'https://cdn.shopify.com/s/files/1/0715/3385/5010/files/231220____gif_PC_jpg_____vF.jpg?v=1703062579") no-repeat center/cover','height':'0', 'padding':'0 0 32.8% 0'});       
          $('.collection-hero').css({'background':'url("https://cdn.shopify.com/s/files/1/0715/3385/5010/files/pc_Msw2_Ayj5.png?v=1703054006") no-repeat center/cover'}); 
        }      
      }
      resizeShopBg();
      
      $(window).resize(function(){
        resizeShopBg();
      }).resize();
    }
  }
  */

  // innercare gel delay
  /*
  if (
    getWorldTime(+9) > "2024-02-15 00:00:00" ||
    preview[1] == "true" ||
    preview_[1] == "true"
  ) {
    if (
      $("#QuickAdd-8462415135010").attr("open") ||
      $("#Badge--8462415135010").length > 0 ||
      $("#QuickAdd-8269916733730").attr("open") ||
      $("#Badge--8269916733730").length > 0 ||
      $("#QuickAdd-8845709934882").attr("open") ||
      $("#Badge--8845709934882").length > 0 ||
      $("#QuickAdd-8269926269218").attr("open") ||
      $("#Badge--8269926269218").length > 0 ||
      $("#QuickAdd-8269925220642").attr("open") ||
      $("#Badge--8269925220642").length > 0 ||
      $("#QuickAdd-8845718323490").attr("open") ||
      $("#Badge--8845718323490").length > 0 ||
      $("#QuickAdd-8845702365474").attr("open") ||
      $("#Badge--8845702365474").length > 0 ||
      $("#QuickAdd-8269927481634").attr("open") ||
      $("#Badge--8269927481634").length > 0 ||
      $("#QuickAdd-8845746962722").attr("open") ||
      $("#Badge--8845746962722").length > 0 ||
      $("#QuickAdd-8269928235298").attr("open") ||
      $("#Badge--8269928235298").length > 0
    ) {
      $(".product__info-container").after(
        '<div id="ic_notice" class="fs14" style="margin-top:15px"></div>'
      );
      $("#ic_notice").html(
        "<strong class='fs22' style='color:black'>Sorry, this product is temporarily out of stock.</strong><br/><br/>Your order will be processed normally, but there might be a 5-7 delivery delay.<br/>We apologize for any inconvenience and appreciate your patience.<br/><br/><strong style='color:red'>*If you have already placed an order, please check your email inbox.</strong>"
      );
    }
  }
  
  */
  /* save 30% */
  $(
    "#NoMediaStandardBadge-template--15249818321005__product-grid-7218398953581,#NoMediaStandardBadge-template--15486087004269__product-grid-7218398953581,#NoMediaStandardBadge-template--15249819009133__featured_collection-7218398953581, #NoMediaStandardBadge-template--15249818321005__product-grid-7206583664749"
  ).text("Save 30%");
  /* save 25% */
  $(
    "#NoMediaStandardBadge-template--15249818321005__product-grid-7206582059117, #NoMediaStandardBadge-template--15486087004269__product-grid-7206582059117"
  ).text("Save 25%");
  /* save 15% */
  $(
    "#NoMediaStandardBadge-template--15249818321005__product-grid-7218368249965 ,#NoMediaStandardBadge-template--15249818321005__product-grid-7270355730541,#NoMediaStandardBadge-template--15249818321005__product-grid-7206587170925"
  ).text("Save 15%");
  /* save 10% */
  $(
    "#NoMediaStandardBadge-template--15249818321005__product-grid-7206557122669 , #NoMediaStandardBadge-template--15486087004269__product-grid-7206557122669, #NoMediaStandardBadge-template--15249818321005__product-grid-7218300780653"
  ).text("Save 10%");

  if ($(".buy_btn + .product__text").length > 0) {
    if (
      getWorldTime(+9) < "2023-11-09 16:00:00" ||
      preview[1] == "true" ||
      preview_[1] == "true"
    ) {
      $(".buy_btn + .product__text").show();
      $(".buy_btn + .product__text .custom_detail")
        .removeClass("fs20")
        .addClass("fs16");
    } else {
      $(".buy_btn + .product__text").remove();
    }
  }
});
